import { NavLink } from "react-router-dom";
import { t } from "@/i18n";

export function AdminGarageTabs() {
  const cls = ({ isActive }) => `border-b-2 px-4 py-2.5 text-sm font-semibold transition-colors duration-150 ${isActive ? "border-teal-500 text-slate-900" : "border-transparent text-slate-500 hover:text-slate-800"}`;
  return (
    <nav className="mb-6 flex gap-1 border-b border-slate-200" data-testid="admin-garage-tabs">
      <NavLink to="/admin/garages" className={cls} data-testid="admin-tab-garages">{t("admin.nav.garages")}</NavLink>
      <NavLink to="/admin/signup-requests" className={cls} data-testid="admin-tab-signup-requests">{t("p7.approval.nav")}</NavLink>
    </nav>
  );
}
